const DEFAULTS = {
    // Variation
    variationImageChange: true,
    variationGallery: true,

    // Zoom
    zoomType: "inner", // 'lens' | 'inner' | 'window'
    zoomLevel: 2.5,
    lensSize: 130, // px diameter/side
    lensShape: "circle", // 'circle' | 'square'
    lensBorderColor: "#ffffff",
    lensBorderWidth: 2,
    zoomWindowSizeMode: "custom", // 'custom' | 'auto' | 'match'
    zoomWindowWidth: 400,
    zoomWindowHeight: 400,
    zoomWindowPosition: "right", // 'right'|'left'|'top'|'bottom'
    zoomWindowOffsetX: 14,
    zoomWindowOffsetY: 0,
    zoomWindowBorderRadius: 8,
    zoomWindowBorderColor: "#e0e0e0",
    zoomWindowBorderWidth: 1,
    zoomWindowShadow: true,
    zoomWindowFadeEasing: true,
    zoomWindowFadeEasingAmount: 300, // ms

    // Cursor overlay shown on the main image for window-type zoom
    zoomWindowCursor: true, // show/hide the overlay
    zoomWindowCursorSizeMode: "auto", // 'auto' | 'custom'
    zoomWindowCursorWidth: 100, // px, used when sizeMode=custom
    zoomWindowCursorHeight: 100, // px, used when sizeMode=custom
    zoomWindowCursorBorderRadius: 4, // px, 0 = square
    zoomWindowCursorBg: "rgba(255,255,255,0.50)", // fill of the selection box
    zoomWindowCursorBorderColor: "#ffffff", // border color
    zoomWindowCursorBorderWidth: 1, // border thickness px

    zoomCursor: "crosshair",
    zoomOnHover: true,
    zoomEasing: true,
    zoomEasingAmount: 12,

    // Touch / Mobile
    touchZoom: true,
    touchZoomMin: 1,
    touchZoomMax: 5,
    swipeThreshold: 50,

    // Gallery type
    galleryType: "thumbnail", // 'thumbnail' | 'anchor' | 'sticky-split' | 'hierarchy-grid'

    // Thumbnails
    thumbnailShow: true, // show or hide the thumbnail strip entirely
    thumbnailPosition: "bottom", // 'bottom'|'top'|'left'|'right'
    thumbnailLayout: "slider", // 'slider' | 'grid'
    thumbnailWidth: 80,
    thumbnailHeight: 80,
    thumbnailAspectRatio: "auto", // 'auto' | '1/1' | '4/3' | '3/2' | '16/9' | '3/4' | '2/3'
    thumbnailGap: 8,
    thumbnailStripGap: 8, // px gap between the thumbnail strip and the main image area
    thumbnailBorderRadius: 4,
    thumbnailBackground: "", // background color of each thumbnail item (empty = none)
    thumbnailActiveBorderColor: "rgba(0, 0, 0, 0.82)",
    thumbnailActiveBorderWidth: 2,
    thumbnailSliderButtons: true,
    thumbnailSlideType: "row", // 'row' = slide a visible row at once | 'item' = slide one item
    thumbnailLoop: false, // wrap around from last→first and first→last
    thumbnailDragNav: true, // drag / touch-drag scrolls the thumbnail strip
    thumbnailScrollNav: true, // scroll wheel / trackpad scrolls the thumbnail strip
    thumbnailVisible: 5,
    thumbnailGridColumns: 4,
    thumbnailFitToImage: false,
    thumbnailTrigger: "click", // 'click' | 'hover'
    thumbnailArrowsOverlay: false, // true = arrows float over the track
    thumbnailAlignment: "left", // 'left' | 'center' | 'right' (horizontal strips only)
    thumbnailBreakpoint: 1025, // px: below this width, left/right stacks to bottom (0 = disabled)
    thumbnailAnimation: true, // staggered fade-in entrance animation for thumbnail items

    // Main image display
    mainImageHeightMode: "lock", // 'lock' | 'adaptive' | 'fixed'
    mainImageHeight: 0, // px, used when mainImageHeightMode === 'fixed'
    mainImageFit: "contain", // 'contain' | 'cover'
    mainImageBackground: "",
    mainImageBorderRadius: 6, // px
    mainImageBorderWidth: 0, // px — border around the main image wrap
    mainImageBorderColor: "#e0e0e0",
    mainImageShadow: false,

    // Main image navigation
    mainImageArrows: true, // prev/next arrows overlaid on main image
    mainImageArrowsAutoHide: true, // hide arrows when cursor leaves; false = always visible
    mainImageArrowIcon: "chevron", // 'chevron' | 'arrow' | 'caret' | 'angle' | 'thin'
    mainImageArrowSize: 40, // px — diameter of the arrow buttons
    mainImageArrowBorderRadius: 50, // % — border radius of the arrow buttons (50 = circle)
    mainImageArrowIconSize: 18, // px — size of the SVG icon inside the arrow button
    mainImageArrowBg: "rgba(255,255,255,0.92)", // normal background
    mainImageArrowColor: "#1a1a1a", // normal icon color
    mainImageArrowHoverBg: "rgba(0,0,0,0.82)", // hover background
    mainImageArrowHoverColor: "#ffffff", // hover icon color
    mainImagePagination: true, // dot indicators below main image
    mainImagePaginationAutoHide: true, // auto-hide dots when cursor leaves; false = always visible
    mainImagePaginationType: "dots", // 'dots' | 'progressbar'
    mainImagePaginationPosition: "bottom", // 'bottom' | 'left' | 'right'
    mainImageDotSize: 5, // px — diameter of the inactive pagination dot
    mainImageDotColor: "rgba(0,0,0,0.2)", // inactive dot colour
    mainImageDotActiveColor: "rgba(0,0,0,0.82)", // active dot colour
    mainImageSwipe: false, // swipe left/right on the main image to navigate (requires zoomOnHover and touchZoom both disabled)
    mainImageScrollNav: false, // scroll wheel on the main image to navigate next/prev (both scroll directions)
    mainImageScrollNavDelay: 700, // ms cooldown between scroll-triggered navigations

    // Stacked layout (Anchor Navigation mode)
    stackedItemGap: 24, // px gap between stacked items
    stackedNavigationType: "dots", // 'dots' | 'thumbs'
    anchorZoom: true, // enable zoom on hover for stacked image items (requires zoomOnHover)
    stackedThumbsStickyTop: 40, // px — sticky top offset for left/right thumb strip in stacked layout
    stackedDotsPosition: "outside", // 'overlay' | 'outside'
    stackedDotGap: 8, // px gap between dots
    stackedDotSize: 8, // px diameter of each dot
    stackedDotColor: "rgba(0, 0, 0, 0.5)", // inactive dot colour
    stackedDotActiveColor: "#000000", // active dot colour

    // Stacked layout — sticky product summary
    stackedStickyEnabled: false, // keep the product summary sticky while scrolling the gallery
    stackedStickySelector: ".summary.entry-summary", // CSS selector for the summary element
    stackedStickyTop: 100, // px — sticky top offset for the summary
    stackedStickyBreakpoint: 1024, // px — disable sticky below this viewport width (0 = always on)
    stackedStickyFixOverflow: true, // patch ancestor overflow:hidden/clip to unblock position:sticky

    // Sticky Split layout
    stickySplitMainSide: "left", // 'left' | 'right' — which column holds the sticky viewer
    stickySplitMainWidthPercent: 65, // % width of the sticky main column
    stickySplitGap: 20, // px gap between the two columns
    stickySplitStickyTop: 50, // px top offset for position:sticky on the main viewer
    stickySplitScrollItemGap: 20, // px gap between scroll items in the right column
    stickySplitScrollItemAspect: "auto", // CSS aspect-ratio ('auto'|'1/1'|'4/3'|'3/2'|'16/9')
    stickySplitScrollItemFit: "cover", // 'contain' | 'cover' — object-fit on scroll item images
    stickySplitScrollItemBorderRadius: 6, // px border-radius on each scroll item
    stickySplitShowCaption: false, // show caption text below each scroll item
    stickySplitClickAction: "lightbox", // 'lightbox' | 'none' — what clicking a scroll item does
    stickySplitClickSync: false, // update main viewer when a scroll item is clicked
    stickySplitThumbZoom: false, // enable zoom on hover for scroll column images
    stickySplitShowMainInScroll: false, // include the main product image as the first item in the scroll column

    // Hierarchy Grid layout
    hierarchyGridColumns: 2, // columns in the grid below the hero image
    hierarchyGridGap: 16, // px gap between items
    hierarchyGridItemAspect: "1/1", // CSS aspect-ratio applied to each grid cell ('auto'|'1/1'|'4/3'|'3/2'|'16/9')
    hierarchyGridItemFit: "cover", // 'contain' | 'cover' — object-fit on grid item images
    hierarchyGridItemBorderRadius: 6, // px border-radius on each item
    hierarchyGridZoom: true, // enable zoom on hover for grid items (requires zoomOnHover)

    // Tiles layout
    tilesColumns: 2, // number of equal-width columns
    tilesGap: 8, // px gap between tiles
    tilesItemAspect: "3/2", // CSS aspect-ratio per tile ('auto'|'1/1'|'4/3'|'3/2'|'16/9')
    tilesItemFit: "cover", // 'contain' | 'cover' — object-fit on tile images
    tilesItemBorderRadius: 0, // px border-radius on each tile
    tilesInitialCount: 6, // number of tiles visible before "Show More"
    tilesShowMoreEnabled: true, // show/hide the Show More / Show Less button
    tilesShowMoreText: "Show More", // text on the expand button
    tilesShowLessText: "Show Less", // text on the collapse button
    tilesZoom: true, // enable zoom on hover for tiles (requires zoomOnHover)

    mobileBreakpoint: 768, // px — below this, mobile settings take effect
    mobileShowThumbs: false, // show thumbnail strip in the mobile carousel fallback
    mobileThumbnailPosition: "bottom", // 'bottom' | 'top' | 'left' | 'right'
    mobileThumbnailWidth: 100, // px — thumbnail item width on mobile (0 = use desktop thumbnailWidth)
    mobileThumbnailHeight: 100, // px — thumbnail item height on mobile (0 = use desktop thumbnailHeight)
    mobileArrows: true, // show prev/next arrows in the mobile carousel fallback
    mobilePagination: true, // show dot pagination in the mobile carousel fallback
    mobilePaginationPosition: "bottom", // 'bottom' | 'left' | 'right'

    // Lightbox
    lightbox: true,
    lightboxOnClick: true, // show trigger button (expand icon)
    lightboxButtonAutoHide: true, // hide expand button when cursor leaves; false = always visible
    lightboxButtonPosition: "bottom-right", // 'bottom-right'|'bottom-left'|'top-right'|'top-left'
    lightboxOverlayColor: "rgba(5, 5, 8, 0.95)", // background color (with alpha) of the lightbox overlay
    lightboxOpenOnImageClick: false, // also/instead open on main image click (WP setting)
    lightboxLoop: true,
    lightboxShowCounter: true,
    lightboxShowCaption: true,
    lightboxShowThumbnails: true,
    lightboxPaginationType: "thumbs", // 'thumbs' | 'dots'
    lightboxCloseOnOverlay: true,
    lightboxKeyboard: true,
    lightboxAnimationDuration: 320,
    lightboxTransition: "slide", // 'slide'|'fade'|'zoom'|'none'
    lightboxAutoplay: false, // autoplay slideshow in lightbox
    lightboxAutoplayDelay: 3500, // ms between slides
    lightboxShowAutoplayButton: true, // show/hide autoplay toggle button in toolbar
    lightboxZoomIn: true, // enable zoom-in/out buttons in lightbox toolbar
    lightboxScrollZoom: true, // enable mouse wheel zoom on lightbox image
    lightboxFullscreen: true, // enable fullscreen button
    lightboxShowArrows: true, // show prev/next navigation arrows
    lightboxSwipe: true, // swipe / drag to navigate between images
    lightboxSingleImage: false, // show only the clicked image (no gallery navigation)
    lightboxImageBorderRadius: 6, // px, border-radius of the main lightbox image
    lightboxThumbBorderRadius: 5, // px, border-radius of thumbnail strip items
    lightboxZoomOrigin: false, // zoom open/close animation from/to the source image position
    lightboxImageTools: true, // show center image transformation toolbar (rotate, flip, 1:1)
    lightboxShare: false, // show share button in lightbox toolbar
    lightboxShareFacebook: true, // show Facebook share option
    lightboxShareTwitter: true, // show Twitter/X share option
    lightboxSharePinterest: true, // show Pinterest share option
    lightboxShareDownload: true, // show download image option

    // Transition
    mainImageTransition: "slide", // 'fade'|'slide'|'zoom'|'none'
    mainImageTransitionDuration: 500,
    mainImageSlideDirection: "horizontal", // 'horizontal' | 'vertical' (slide transition only)

    // Spinner
    spinner: false,
    spinnerColor: "rgba(0, 0, 0, 0.82)",

    // Video
    videoPosition: "end", // 'start' | 'end' — where product videos appear in the thumbnail strip
    videoAutoplay: false, // autoplay embed when navigated to (muted required for most browsers)
    videoMuted: true, // mute embed by default (needed for autoplay)
    videoLoop: false, // loop YouTube / Vimeo embeds
    videoHideRelated: true, // hide related videos at end (YouTube rel=0)
    videoEmbedControls: true, // show player controls on YouTube / Vimeo embeds
    videoEmbedFitContainer: false, // fill the main image area (crop embed to match container)
    videoControls: true, // show controls on hosted <video> elements
    videoHostedLoop: false, // loop hosted (uploaded) video files
    videoHostedAutoplay: false, // autoplay hosted video when navigated to
    videoHostedMuted: false, // mute hosted video (useful with autoplay)
    videoHostedFitContainer: false, // fill the main image area (crop hosted video to match container)

    // Misc
    preloadImages: true,
    zoomBeforeLoad: false,
    dataImageAttr: "data-zoom-image",
    dataCaptionAttr: "data-caption",

    // Callbacks
    onInit: null,
    onZoomStart: null,
    onZoomEnd: null,
    onThumbClick: null,
    onImageChange: null,
    onLightboxOpen: null,
    onLightboxClose: null,
};

export default DEFAULTS;
